export default __webpack_public_path__ + "static/media/mobile_krush.4ee7421d.webp";